/* ============================================================
   SUNTEX • assets/suntex-pack.js  (v2 — multi-variant)
   ------------------------------------------------------------
   - Galerie : navigation entre slides + thumbnails + clavier
   - Multi-variant picker : qty +/- par couleur, calcul total
   - /cart/add.js : add multi-items en 1 appel
   - Cart drawer natif Dawn/Horizon ou fallback /cart
   ============================================================ */

(function () {
  'use strict';

  // ──────────────────────────────────────────────────────────
  // BOOTSTRAP
  // ──────────────────────────────────────────────────────────
  function init() {
    document.querySelectorAll('[data-suntex-pdp]').forEach(function (el) {
      if (!el.__sxInit) { new SuntexPDP(el); el.__sxInit = true; }
    });
  }

  // ──────────────────────────────────────────────────────────
  // LIGHTBOX MODULE
  // ──────────────────────────────────────────────────────────
  function Lightbox(slides) {
    this.slides = slides.map(function (s) {
      var img = s.querySelector('img');
      return img ? img.src.replace(/&?width=\d+/g, '') + '&width=2000' : null;
    }).filter(Boolean);
    this.currentIndex = 0;
    this.el = null;
    this.imgEl = null;
    this.counterEl = null;
    this.keyHandler = null;
  }

  Lightbox.prototype.build = function () {
    if (this.el) return;
    var box = document.createElement('div');
    box.className = 'suntex-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<div class="suntex-lightbox__inner">' +
        '<button type="button" class="suntex-lightbox__close" aria-label="Fermer">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        '<button type="button" class="suntex-lightbox__nav suntex-lightbox__nav--prev" aria-label="Précédente">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>' +
        '<img class="suntex-lightbox__img" alt="">' +
        '<button type="button" class="suntex-lightbox__nav suntex-lightbox__nav--next" aria-label="Suivante">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>' +
        '<div class="suntex-lightbox__counter">1 / 1</div>' +
      '</div>';
    document.body.appendChild(box);
    this.el = box;
    this.imgEl = box.querySelector('.suntex-lightbox__img');
    this.counterEl = box.querySelector('.suntex-lightbox__counter');

    var self = this;
    box.querySelector('.suntex-lightbox__close').addEventListener('click', function () { self.close(); });
    box.querySelector('.suntex-lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); self.go(self.currentIndex - 1); });
    box.querySelector('.suntex-lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); self.go(self.currentIndex + 1); });
    // Click outside image closes
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('suntex-lightbox__inner')) self.close();
    });
    // Toggle 2x zoom on image click
    this.imgEl.addEventListener('click', function () {
      self.imgEl.classList.toggle('is-zoomed');
    });
    // Touch swipe
    var startX = 0;
    this.imgEl.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    this.imgEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50 && !self.imgEl.classList.contains('is-zoomed')) {
        self.go(self.currentIndex + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });
  };

  Lightbox.prototype.open = function (index) {
    if (this.slides.length === 0) return;
    this.build();
    this.go(index || 0);
    this.el.classList.add('is-open');
    document.body.classList.add('suntex-lightbox-open');
    // Keyboard
    var self = this;
    this.keyHandler = function (e) {
      if (e.key === 'Escape')   self.close();
      if (e.key === 'ArrowLeft')  self.go(self.currentIndex - 1);
      if (e.key === 'ArrowRight') self.go(self.currentIndex + 1);
    };
    document.addEventListener('keydown', this.keyHandler);
  };

  Lightbox.prototype.close = function () {
    if (!this.el) return;
    this.el.classList.remove('is-open');
    this.imgEl.classList.remove('is-zoomed');
    document.body.classList.remove('suntex-lightbox-open');
    if (this.keyHandler) {
      document.removeEventListener('keydown', this.keyHandler);
      this.keyHandler = null;
    }
  };

  Lightbox.prototype.go = function (index) {
    if (this.slides.length === 0) return;
    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;
    this.currentIndex = index;
    this.imgEl.classList.remove('is-zoomed');
    this.imgEl.src = this.slides[index];
    this.counterEl.textContent = (index + 1) + ' / ' + this.slides.length;
  };

  // ──────────────────────────────────────────────────────────
  // GALLERY MODULE
  // ──────────────────────────────────────────────────────────
  function Gallery(root) {
    this.root = root;
    this.stage = root.querySelector('[data-suntex-media-stage]');
    this.slides = Array.from(root.querySelectorAll('[data-suntex-slide]'));
    this.thumbs = Array.from(root.querySelectorAll('[data-suntex-thumb]'));
    this.prevBtn = root.querySelector('[data-suntex-nav="prev"]');
    this.nextBtn = root.querySelector('[data-suntex-nav="next"]');
    this.activeIndex = 0;

    var self = this;
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.go(parseInt(t.dataset.index, 10)); });
    });
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(self.activeIndex - 1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(self.activeIndex + 1); });

    // ─── LIGHTBOX ZOOM ───
    this.lightbox = new Lightbox(this.slides);
    // Click sur l'image principale → ouvre lightbox sur la slide active
    this.slides.forEach(function (s, idx) {
      var img = s.querySelector('img');
      if (img) img.addEventListener('click', function (e) {
        e.preventDefault();
        self.lightbox.open(idx);
      });
    });
    // Click sur le bouton loupe → ouvre lightbox sur la slide active
    var zoomBtn = root.querySelector('.suntex-pdp__zoom-btn');
    if (zoomBtn) zoomBtn.addEventListener('click', function () {
      self.lightbox.open(self.activeIndex);
    });

    // Keyboard
    root.tabIndex = 0;
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); self.go(self.activeIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.activeIndex + 1); }
    });

    // Touch swipe
    var startX = 0, startY = 0, isSwiping = false;
    this.stage.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; isSwiping = true;
    }, { passive: true });
    this.stage.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        self.go(self.activeIndex + (dx < 0 ? 1 : -1));
      }
      isSwiping = false;
    }, { passive: true });
  }

  Gallery.prototype.go = function (index) {
    if (this.slides.length === 0) return;
    if (index < 0) index = this.slides.length - 1;
    if (index >= this.slides.length) index = 0;
    this.slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    this.thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    var activeThumb = this.thumbs[index];
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
    }
    this.activeIndex = index;
  };

  Gallery.prototype.goToMediaId = function (mediaId) {
    if (!mediaId) return;
    var idx = this.slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
    if (idx >= 0) this.go(idx);
  };

  // ──────────────────────────────────────────────────────────
  // MAIN PDP CONTROLLER
  // ──────────────────────────────────────────────────────────
  function SuntexPDP(root) {
    this.root = root;
    this.gallery = new Gallery(root.querySelector('[data-suntex-media]'));

    // Variant cards
    this.variantCards = Array.from(root.querySelectorAll('[data-suntex-variant]'));
    this.variantsData = this.variantCards.map(function (card) {
      return {
        el: card,
        id: card.dataset.variantId,
        color: card.dataset.colorName,
        stock: parseInt(card.dataset.stock, 10) || 0,
        unitPrice: card.dataset.unitPrice === '' ? null : parseFloat(card.dataset.unitPrice),
        packPrice: (parseInt(card.dataset.packPriceCents, 10) || 0) / 100,
        pcs: parseInt(card.dataset.piecesPerPack, 10) || 0,
        packLabel: card.dataset.packLabel || '',
        breakdown: card.dataset.packBreakdown || '',
        mediaId: card.dataset.mediaId,
        hasPackData: card.dataset.hasPackData === 'true',
        qtyInput: card.querySelector('[data-suntex-qty-input]'),
        msgEl: card.querySelector('[data-suntex-msg]'),
      };
    });

    // Refs
    this.totalPacksEl       = root.querySelector('[data-suntex-total-packs]');
    this.totalPiecesEl      = root.querySelector('[data-suntex-total-pieces]');
    this.totalPriceEl       = root.querySelector('[data-suntex-total-price]');
    this.totalPacksPlural   = root.querySelector('[data-suntex-total-packs-plural]');
    this.totalPiecesPlural  = root.querySelector('[data-suntex-total-pieces-plural]');
    this.cta                = root.querySelector('[data-suntex-cta]');
    this.ctaLabel           = this.cta && this.cta.querySelector('.suntex-pdp__cta-label');
    this.ctaSpinner         = this.cta && this.cta.querySelector('.suntex-pdp__cta-spinner');
    this.feedbackEl         = root.querySelector('[data-suntex-feedback]');
    this.breakdownBody      = root.querySelector('[data-suntex-breakdown-body]');

    this.bindEvents();
    this.recompute();
  }

  SuntexPDP.prototype.bindEvents = function () {
    var self = this;

    this.variantsData.forEach(function (data) {
      // +/-/input
      var qtyBtns = data.el.querySelectorAll('[data-suntex-qty]');
      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.dataset.suntexQty, 10) || 0;
          self.setQty(data, (parseInt(data.qtyInput.value, 10) || 0) + delta);
        });
      });
      data.qtyInput.addEventListener('input', function () {
        self.setQty(data, parseInt(data.qtyInput.value, 10) || 0, true);
      });
      data.qtyInput.addEventListener('change', function () {
        self.setQty(data, parseInt(data.qtyInput.value, 10) || 0);
      });

      // Click variant card → show its media
      data.el.addEventListener('click', function (e) {
        // ignore if click is on +/- or input
        if (e.target.closest('[data-suntex-qty-wrap]')) return;
        if (data.mediaId) self.gallery.goToMediaId(data.mediaId);
      });
    });

    // CTA add to cart
    if (this.cta) {
      this.cta.addEventListener('click', function () { self.addToCart(); });
    }
  };

  SuntexPDP.prototype.setQty = function (data, qty, isLiveInput) {
    // Safety: misconfigured variants always force qty=0
    if (!data.hasPackData) {
      data.qtyInput.value = 0;
      if (data.msgEl) {
        data.msgEl.textContent = 'Conditionnement à compléter dans Shopify Admin';
        data.msgEl.classList.add('is-warning');
      }
      data.el.classList.remove('is-selected');
      this.recompute();
      return;
    }

    if (qty < 0) qty = 0;
    var clamped = false;
    if (qty > data.stock) {
      qty = data.stock;
      clamped = true;
    }
    data.qtyInput.value = qty;
    if (data.msgEl) {
      if (clamped) {
        data.msgEl.textContent = 'Stock maximum atteint (' + data.stock + ')';
        data.msgEl.classList.add('is-warning');
      } else {
        data.msgEl.textContent = '';
        data.msgEl.classList.remove('is-warning');
      }
    }
    data.el.classList.toggle('is-selected', qty > 0);
    this.recompute();
  };

  SuntexPDP.prototype.parseBreakdown = function (str) {
    if (!str) return [];
    return str.split(',').map(function (p) {
      var parts = p.split(':');
      return [(parts[0] || '').trim(), parseInt((parts[1] || '0').trim(), 10) || 0];
    }).filter(function (r) { return r[0] && r[1] > 0; });
  };

  SuntexPDP.prototype.formatMoney = function (amount) {
    if (amount === Math.floor(amount)) {
      try { return new Intl.NumberFormat('fr-FR').format(amount) + ' €'; }
      catch (e) { return amount + ' €'; }
    }
    try {
      return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount) + ' €';
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + ' €';
    }
  };

  SuntexPDP.prototype.recompute = function () {
    var totalPacks = 0;
    var totalPieces = 0;
    var totalPrice = 0;
    var selected = [];

    this.variantsData.forEach(function (d) {
      var q = parseInt(d.qtyInput.value, 10) || 0;
      // Skip misconfigured variants entirely
      if (q > 0 && d.hasPackData) {
        totalPacks += q;
        totalPieces += d.pcs * q;
        totalPrice += d.packPrice * q;
        selected.push({ data: d, qty: q });
      }
    });

    // Update totals
    if (this.totalPacksEl)  this.totalPacksEl.textContent = totalPacks;
    if (this.totalPiecesEl) this.totalPiecesEl.textContent = totalPieces;
    if (this.totalPriceEl)  this.totalPriceEl.textContent = this.formatMoney(totalPrice);
    if (this.totalPacksPlural)  this.totalPacksPlural.textContent  = totalPacks  > 1 ? 's' : '';
    if (this.totalPiecesPlural) this.totalPiecesPlural.textContent = totalPieces > 1 ? 's' : '';

    // Update CTA
    if (this.cta && this.ctaLabel) {
      if (totalPacks === 0) {
        this.cta.disabled = true;
        this.ctaLabel.textContent = 'Sélectionnez une quantité';
      } else {
        this.cta.disabled = false;
        this.ctaLabel.textContent = 'Ajouter ' + totalPacks + ' paquet' + (totalPacks > 1 ? 's' : '') + ' au panier';
      }
    }

    // Render grouped breakdown
    this.renderBreakdown(selected, totalPieces);
  };

  SuntexPDP.prototype.renderBreakdown = function (selected, totalPieces) {
    if (!this.breakdownBody) return;
    if (selected.length === 0) {
      this.breakdownBody.innerHTML = '<p class="suntex-pdp__breakdown-empty">Aucune couleur sélectionnée pour l\'instant.</p>';
      return;
    }
    var self = this;
    var html = '';
    selected.forEach(function (sel) {
      var d = sel.data;
      var qty = sel.qty;
      var bd = self.parseBreakdown(d.breakdown);
      html += '<div class="suntex-pdp__bd-group">'
            +   '<div class="suntex-pdp__bd-group-head">'
            +     '<span class="suntex-pdp__bd-color">' + escapeHtml(d.color) + '</span>'
            +     '<span class="suntex-pdp__bd-meta">' + qty + ' paquet' + (qty > 1 ? 's' : '') + ' · ' + (d.pcs * qty) + ' pcs</span>'
            +   '</div>'
            +   '<table class="suntex-pdp__bd-table">'
            +     '<thead><tr><th>Taille</th><th>Qté/paquet</th><th>Total</th></tr></thead>'
            +     '<tbody>'
            +       bd.map(function (row) {
                      return '<tr><td>' + escapeHtml(row[0]) + '</td><td>' + row[1] + '</td><td>' + (row[1] * qty) + '</td></tr>';
                    }).join('')
            +     '</tbody>'
            +   '</table>'
            + '</div>';
    });
    html += '<div class="suntex-pdp__bd-total">Total pièces : <strong>' + totalPieces + '</strong></div>';
    this.breakdownBody.innerHTML = html;
  };

  // ──────────────────────────────────────────────────────────
  // CART INTEGRATION (Horizon native + Dawn fallback)
  // ──────────────────────────────────────────────────────────

  // Liste des candidats par ordre de priorité pour le drawer
  function findCartDrawer() {
    return document.querySelector('cart-drawer-component')   // Horizon (2025+)
        || document.querySelector('cart-drawer')             // Dawn / autres
        || document.querySelector('[data-cart-drawer]')      // fallback générique
        || null;
  }

  // Trouve les sections qui contiennent le cart UI (à rafraîchir après add)
  function findCartSectionIds() {
    var ids = new Set();
    document.querySelectorAll('cart-drawer-component, cart-drawer, cart-icon, cart-icon-bubble, cart-bubble, cart-notification, [data-cart-drawer]').forEach(function (el) {
      var wrap = el.closest('[id^="shopify-section-"]');
      if (wrap) ids.add(wrap.id.replace(/^shopify-section-/, ''));
    });
    return Array.from(ids);
  }

  SuntexPDP.prototype.buildLineItems = function () {
    var items = [];
    this.variantsData.forEach(function (d) {
      var qty = parseInt(d.qtyInput.value, 10) || 0;
      // Skip misconfigured variants (safety check, qty input is already disabled)
      if (qty <= 0 || !d.hasPackData) return;

      // Build properties only with the values that are actually set
      var props = {
        'Type de vente': 'Vendu par paquet',
        'Couleur': d.color
      };
      if (d.unitPrice !== null && !isNaN(d.unitPrice)) props['Prix unitaire'] = d.unitPrice + ' € HT / Unit';
      if (d.pcs > 0)         props['Pièces par paquet'] = String(d.pcs);
      if (d.packLabel)       props['Conditionnement'] = d.packLabel;
      if (d.breakdown)       props['Répartition du paquet'] = d.breakdown;
      if (d.pcs > 0)         props['Nombre total de pièces'] = String(d.pcs * qty);

      items.push({
        id: parseInt(d.id, 10),
        quantity: qty,
        properties: props
      });
    });
    return items;
  };

  SuntexPDP.prototype.addToCart = async function () {
    if (this.cta.disabled) return;

    var items = this.buildLineItems();
    if (items.length === 0) return;

    this.setLoading(true);
    this.setFeedback('', '');

    try {
      await addSuntexSelectionToCart(items);
      this.setFeedback('Ajouté au panier !', 'ok');
      // Reset quantities
      this.variantsData.forEach(function (d) {
        d.qtyInput.value = 0;
        d.el.classList.remove('is-selected');
      });
      this.recompute();
    } catch (err) {
      console.error('[suntex] cart add error', err);
      var msg = (err && err.description) || (err && err.message) || 'Erreur lors de l\'ajout au panier';
      this.setFeedback(msg, 'error');
    } finally {
      this.setLoading(false);
    }
  };

  /**
   * SUNTEX • addSuntexSelectionToCart
   * ----------------------------------
   * Ajoute plusieurs items au panier en une seule requête /cart/add.js,
   * rafraîchit les sections qui contiennent le cart drawer, et ouvre
   * le drawer natif Horizon (<cart-drawer-component>).
   *
   * Fallback chain :
   *   1. <cart-drawer-component>.open()      [Horizon natif]
   *   2. <cart-drawer>.open()                [Dawn natif]
   *   3. CartAddEvent dispatch 'cart:update' [Horizon listeners]
   *   4. redirect /cart                       [last resort]
   */
  async function addSuntexSelectionToCart(items) {
    if (!Array.isArray(items) || items.length === 0) throw new Error('Aucun item à ajouter');

    // 1. Découvrir les sections cart à rafraîchir (avant l'ajout)
    var sectionIds = findCartSectionIds();

    // 2. POST /cart/add.js avec sections pour récupérer le HTML rendu à jour
    var body = { items: items };
    if (sectionIds.length > 0) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }

    var addResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });

    if (!addResp.ok) {
      var errBody = await addResp.json().catch(function () { return { message: 'HTTP ' + addResp.status }; });
      throw errBody;
    }
    var addJson = await addResp.json();

    // 3. Fetch /cart.js pour avoir l'état complet du panier (item_count, items, etc.)
    var cart;
    try {
      var cartResp = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }});
      cart = await cartResp.json();
    } catch (e) {
      cart = { item_count: 0, items: [] };
    }

    // 4. Replace section DOM avec le HTML retourné par /cart/add.js
    if (addJson.sections) {
      Object.entries(addJson.sections).forEach(function (entry) {
        var sectionId = entry[0];
        var sectionHtml = entry[1];
        if (!sectionHtml) return;
        var target = document.getElementById('shopify-section-' + sectionId);
        if (!target) return;
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sectionHtml, 'text/html');
          var newSection = doc.getElementById('shopify-section-' + sectionId);
          if (newSection) {
            target.innerHTML = newSection.innerHTML;
          } else {
            target.innerHTML = sectionHtml;
          }
        } catch (e) {
          console.warn('[suntex] section replace failed:', sectionId, e);
        }
      });
    }

    // 5. Dispatch l'événement natif Horizon 'cart:update' avec payload conforme à CartAddEvent
    //    Le payload : { resource: <cart>, sourceId: <string>, data: {...} }
    var cartUpdateEvent = new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'suntex-pdp',
        data: { items: items }
      }
    });
    document.dispatchEvent(cartUpdateEvent);

    // 6. Ouvrir le drawer (re-query après section replace, car les custom elements ont été remontés)
    //    Attendre un tick pour laisser custom elements se définir
    await new Promise(function (r) { requestAnimationFrame(r); });

    var drawer = findCartDrawer();
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return; } catch (e) { console.warn('[suntex] drawer.open() failed:', e); }
    }

    // 7. Si pas de drawer ouvrable : essayer de show une cart-notification (Dawn fallback)
    var notif = document.querySelector('cart-notification');
    if (notif && typeof notif.renderContents === 'function') {
      try { notif.renderContents(addJson); return; } catch (e) {}
    }

    // 8. Dernier recours : redirect /cart
    window.location.href = '/cart';
  }

  // Expose pour tests / réutilisation
  window.addSuntexSelectionToCart = addSuntexSelectionToCart;

  SuntexPDP.prototype.setLoading = function (loading) {
    if (!this.cta) return;
    this.cta.classList.toggle('is-loading', loading);
    this.cta.disabled = loading || this.cta.dataset.wasDisabled === 'true';
    if (this.ctaSpinner) this.ctaSpinner.hidden = !loading;
  };

  SuntexPDP.prototype.setFeedback = function (text, type) {
    if (!this.feedbackEl) return;
    this.feedbackEl.textContent = text || '';
    this.feedbackEl.className = 'suntex-pdp__feedback' + (type ? ' is-' + type : '');
  };

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
